/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { z } from "zod";

export const getApiTestSmscodeQueryParamsSchema = z.object({
    "PhoneNumber": z.string()
    })

/**
 * @description Успешно
 */
export const getApiTestSmscode200Schema = z.string()

/**
 * @description Ошибка валидации запроса | Неправильный запрос
 */
export const getApiTestSmscode400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const getApiTestSmscode401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const getApiTestSmscode403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const getApiTestSmscode500Schema = z.lazy(() => badResponseModelSchema)

export const getApiTestSmscodeQueryResponseSchema = z.lazy(() => getApiTestSmscode200Schema)